import { useCallback } from 'react';
import { useTranslation as useTranslationHook } from 'react-i18next';
import { changeLanguage, getCurrentLanguage, isLanguageSupported } from './i18n';

export const useTranslation = () => {
  const { t } = useTranslationHook();

  const switchLanguage = useCallback(async (language: 'en' | 'ko') => {
    if (!isLanguageSupported(language)) {
      console.warn(`Language ${language} is not supported`);
      return false;
    }

    return changeLanguage(language);
  }, []);

  const currentLanguage = getCurrentLanguage();

  const footerTranslations = t('footer', { returnObjects: true });
  const navbarTranslations = t('navbar', { returnObjects: true });
  const cookiesContent = t('cookiesContent', { returnObjects: true });
  const offerCardTranslations = t('offerCard', { returnObjects: true });
  const offersTranslations = t('offers', { returnObjects: true });
  const walletPopupTranslations = t('walletPopup', { returnObjects: true });
  const offerCheckoutTranslations = t('offerCheckout', { returnObjects: true });
  const legalTranslations = t('legal', { returnObjects: true });
  const successPurchaseContent = t('successPurchaseContent', {
    returnObjects: true,
  });
  const guildMemberSelectionTranslations = t('guildMemberSelection', {
    returnObjects: true,
  });
  const walletContent = t('walletContent', { returnObjects: true });
  const errorsTranslations = t('errors', { returnObjects: true });
  const languageSwitcherTranslations = t('languageSwitcher', { returnObjects: true });
  const buttonsTranslations = t('buttons', { returnObjects: true });
  return {
    t,
    switchLanguage,
    currentLanguage,
    footerTranslations,
    navbarTranslations,
    cookiesContent,
    offerCardTranslations,
    offersTranslations,
    walletPopupTranslations,
    successPurchaseContent,
    offerCheckoutTranslations,
    legalTranslations,
    guildMemberSelectionTranslations,
    walletContent,
    errorsTranslations,
    languageSwitcherTranslations,
    buttonsTranslations,
  };
};

export default useTranslation;
